<template>
  <v-chart ref="chart" class="chart" @click="onClick" :option="option" />
</template>

<script>
export default {
  name: 'PieChart1',
  props: {
    casdepart: Array,
    showDemo: String
  },
  created() {
    // if (this.showDemo) {
    //   this.option.legend.show = true
    // }
  },
  data() {
    return {
      option: {},
      owndata: [],
      legendshow: false,
      labelshow: false
    }
  },
  watch: {
    casdepart: {
      handler(newValue, oldValue) {
        this.owndata = newValue
        this.getDataView()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.owndata = this.casdepart
      if (this.showDemo) {
        this.legendshow = true
        this.labelshow = true
        this.getDataView()
      } else {
        setTimeout(() => {
          this.getDataView()
        }, 1000)
      }
    })
  },
  methods: {
    getDataView() {
      // this.axios.get('api/kcapi/get_sexandage').then((response) => {
      this.option = {
        //color: ['#007AFF', '#5ac7a9', '#85C89D', '#f7c241', '#e06d67', '#85C89D', '#fc8452', '#9a60b4', '#ea7ccc'],
        color: ['#007AFF', '#85C89D', '#f7c241', '#e06d67', '#85C89D', '#fc8452', '#9a60b4', '#ea7ccc'],
        legend: {
          bottom: 'bottom',
          show: this.legendshow
        },
        title: {
          //text: '中国科学院 \n\xa0学部分布',
          //text: '美国OSRI',
          text: 'OSRI for USA',
          left: 'center',
          top: '45%',
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            //console.log('[formatter]', params)
            //return params.name +'\n'+ '<b>'+ params.percent + '%' +'</b>';
            return params.name +'\n'+ '<b>'+ params.value  +'</b>';
          }
        },
        grid: {
          top: '40%',
          bottom: '1%'
        },
        series: [
          {
            type: 'pie',
            radius: [50, 80],
            center: ['center', '50%'],
            label: {
              show: this.labelshow,
              formatter: (params) => {
                // return Math.round(params.percent) + '%' + '\n' + params.name
                return params.percent + '%' + '\n' + params.name
              }
            },
            labelLine: {
              length: 5
            },
            data: this.owndata
          }
        ]
      }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    onClick(event, instance, echarts) {
      //window.open('https://ys.cnais.org.cn/cas/searchDoc/kc?city=' + this.$parent.selectcity + '&field=cas&value=' + event.name, '_blank')
    },
    resize() {
      this.$refs['chart'].resize()
    }
  }
}
</script>

<style scope>
/* .chart{
  margin-bottom:10px;
} */
</style>
